export default {
  ui: {
    request: {
      baseUrl: '/mock',
      timeout: 60 * 1000,
    },
    reCaptcha: {
      sitekey: '6LevAF0pAAAAAFulKrh5eBQHSVFgjNPmLSX29Z68',
    },
    noAuthLogOff: false,
    '3rdParties': {
      i18nextDebug: false,
    },
    timeZone: {
      defaultOffsetId: '32',
      defaultOffset: '+00:00',
    },
    hideFeature: {},
    pendoApiKey: undefined,
  },
};
